import { DIALOG } from 'shared/constants';

const handleReceiveMessage = (state, action) => {
  /* console.log('Received message: ', action.payload.message);
        const message = JSON.parse(action.payload.message); */
  // TODO: need to review: this one is using for change format of reponse
  const tmp = JSON.parse(action.payload.message);
  let message = {};
  if (tmp.type === 'typing') {
    // debugger;
    message = JSON.parse({ type: 'typing' });
  } else if (tmp.type === 'message') {
    message = JSON.parse(tmp.text);
    if (message.quick_replies && message.quick_replies.includes('&quot;')) {
      message.quick_replies = JSON.parse(message.quick_replies.replace(/&quot;/g, '"'));
    }
    if (message.appointment && message.appointment.date.includes('&#x2F;')) {
      message.appointment.date = message.appointment.date.replace(/&#x2F;/g, '/');
    }
    message.type = 'message';
  }
  // console.log('Received message: ', message);
  // END OF TODO
  const diffState = {
    investorConversations: message.dialog === DIALOG.INVESTOR_PROFILE ? [...state.investorConversations, message] : [...state.investorConversations],
    riskAssessment: message.dialog === DIALOG.RISK_ASSESSMENT ? [...state.riskAssessment, message] : [...state.riskAssessment],
    investmentPreference: message.dialog === DIALOG.INVESTMENT_PREFERENCE ? [...state.investmentPreference, message] : [...state.investmentPreference],
    currentThread: message.thread ? message.thread : '',
    callToAction: message.dialog === DIALOG.CALL_TO_ACTION ? [...state.callToAction, message] : [...state.callToAction],
    inputComponent: message.componentType ? message.componentType : '',
    inputOptions: message.quick_replies ? message.quick_replies : null,
    messageOptions: message.option,
    isBotTyping: message.typingDelay || 0,
  };

  if (message.dialog === DIALOG.INVESTOR_PROFILE && message.componentType === 'financialGoal') {
    diffState.CMAClassification = message.option.CMA_Classification;
  }

  return Object.assign({}, state, diffState);
};


export default handleReceiveMessage;
